var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDocumentsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 16.5V11.0221C28.5 9.82863 28.0259 8.68404 27.182 7.84012L23.6245 4.28262C22.7806 3.43871 21.636 2.9646 20.4425 2.9646H11.25C9.17893 2.9646 7.5 4.64353 7.5 6.7146V12",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4646 10.4646H23.25C22.0074 10.4646 21 9.45721 21 8.21457V3",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 16.5H19.2037C18.4514 16.5 17.7489 16.124 17.3316 15.4981L15.6675 13.002C15.2502 12.376 14.5477 12 13.7953 12H7.5C5.84315 12 4.5 13.3431 4.5 15V28.5C4.5 30.1569 5.84315 31.5 7.5 31.5H28.5C30.1569 31.5 31.5 30.1569 31.5 28.5V19.5C31.5 17.8431 30.1569 16.5 28.5 16.5Z",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDocumentsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DocumentsIcon.53e82e4c.svg";
export { ForwardRef as ReactComponent };